import type { CanonicalItem, ItemKind } from "@/lib/data";

/**
 * Route slug (plural, URL-safe) for each item kind. Fish and dish keep their
 * original dedicated names ("recipes" reads better than "dishes" in a URL);
 * every other kind uses its plural form.
 */
export const KIND_ROUTE_SLUG: Record<ItemKind, string> = {
  fish: "fish",
  insect: "insects",
  bird: "birds",
  crop: "crops",
  flower: "flowers",
  forageable: "forageables",
  animal: "animals",
  dish: "recipes",
  ingredient: "ingredients",
  material: "materials",
  seed: "seeds",
  vehicle: "vehicles",
  furniture: "furniture",
  tool: "tools",
  clothes: "clothes",
  special: "special",
};

export const ALL_KINDS = Object.keys(KIND_ROUTE_SLUG) as ItemKind[];

export const ROUTES = {
  home: "/",
  items: "/items",
  itemDetail: (id: string) => `/items/${id}`,
  collection: (kind: ItemKind) => `/${KIND_ROUTE_SLUG[kind]}`,
  collectionDetail: (kind: ItemKind, id: string) => `/${KIND_ROUTE_SLUG[kind]}/${id}`,
  // Kept for back-compat call sites.
  fish: "/fish",
  fishDetail: (id: string) => `/fish/${id}`,
  recipes: "/recipes",
  recipeDetail: (id: string) => `/recipes/${id}`,
} as const;

/**
 * The dedicated collection route for an item's kind — every kind now has one
 * (see KIND_ROUTE_SLUG), so this always resolves to `/<slug>/:id` instead of
 * falling back to `/items/:id`.
 */
export function itemDetailPath(item: Pick<CanonicalItem, "id" | "kind">): string {
  return ROUTES.collectionDetail(item.kind, item.id);
}
